import React, { useState } from 'react'
import footercoownspaceLogo from '../../Assests/images/logo/co-own-space-white.png'

const Footer = () => {
    const [formData, setFormData] = useState({
        email: '',
        agree: false,
    });

    const [errors, setErrors] = useState({});
    const [success, setSuccess] = useState('');


    const validate = () => {
        let newErrors = {};
        let trimmedEmail = formData.email.trim();
    
        if (!trimmedEmail) {
            newErrors.email = "Email is required";
        } else if (!/\S+@\S+\.\S+/.test(trimmedEmail)) {
            newErrors.email = "Invalid email format";
        }
        if (!formData.agree) {
            newErrors.agree = "You must authorize CoOwnSpace to contact you";
        }
    
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };
    


    const handleChange = (e) => {
        const { name, type, checked, value } = e.target;
        setFormData({ ...formData, [name]: type === "checkbox" ? checked : value });

    };

    const handleSubmit = async (e) => {
        e.preventDefault();
    
        if (!validate()) return;
    
        try {
            const response = await fetch(process.env.REACT_APP_SEND_EMAIL_NEWSTELLER, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(formData)
            });
    
            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }
    
            const data = await response.json(); 
            if (data.success) {
                setSuccess("Thank you! Your email has been sent successfully.");
                
                setFormData({ email: '', agree: false });
            } else {
                setSuccess("Failed to send email. Try again later.");
            }
        } catch (error) {
            console.error("Fetch Error:", error);
            setSuccess("Error sending email. Try again later.");
        }
    };
    
    return (
        <footer id="footer">
            <div className="tf-container">
                <div className="row">
                    <div className="col-12">
                        <div className="footer-top">
                            <div className="footer-logo">
                                <a href="/">
                                    <img id="logo_footer" src={footercoownspaceLogo} alt="CoOwnSpace Logo" loading="lazy" />
                                </a>
                            </div>
                            <div className="footer-contact">
                                <div className="contact-item">
                                    <div className="icons">
                                        <svg width="48" height="49" viewBox="0 0 48 49" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M43.9989 34.34V40.34C44.0012 40.897 43.8871 41.4483 43.6639 41.9586C43.4408 42.469 43.1135 42.9271 42.703 43.3037C42.2926 43.6802 41.808 43.9669 41.2804 44.1454C40.7527 44.3238 40.1936 44.3901 39.6389 44.34C33.4846 43.6712 27.5729 41.5682 22.3789 38.2C17.5465 35.1293 13.4496 31.0323 10.3789 26.2C6.99885 20.9824 4.89538 15.0419 4.23889 8.85995C4.18891 8.30688 4.25464 7.74947 4.43189 7.2232C4.60914 6.69693 4.89403 6.21333 5.26842 5.80319C5.64281 5.39306 6.0985 5.06537 6.60647 4.84099C7.11444 4.61662 7.66357 4.50047 8.21889 4.49995H14.2189C15.1895 4.4904 16.1305 4.83411 16.8664 5.46702C17.6024 6.09992 18.083 6.97884 18.2189 7.93995C18.4721 9.86008 18.9418 11.7454 19.6189 13.5599C19.888 14.2758 19.9462 15.0538 19.7867 15.8017C19.6272 16.5496 19.2566 17.2362 18.7189 17.78L16.1789 20.3199C19.026 25.327 23.1718 29.4728 28.1789 32.32L30.7189 29.78C31.2627 29.2422 31.9492 28.8716 32.6971 28.7121C33.4451 28.5526 34.223 28.6109 34.9389 28.8799C36.7534 29.5571 38.6388 30.0267 40.5589 30.28C41.5304 30.417 42.4177 30.9064 43.052 31.6549C43.6862 32.4035 44.0232 33.3591 43.9989 34.34Z"
                                                stroke="#F1913D" strokeWidth="2" strokeLinecap="round"
                                            />
                                        </svg>
                                    </div>
                                    <div className="content">
                                        <div className="title text-1">
                                            Call us
                                        </div>
                                        <h6>
                                            <a href="tel:+919941111019" className="text-white">
                                                (+91) 99411 11019
                                            </a>

                                        </h6>
                                    </div>
                                </div>
                                <div className="contact-item">
                                    <div className="icons">
                                        <svg width="48" height="49" viewBox="0 0 48 49" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M40 8.5H8C5.79086 8.5 4 10.2909 4 12.5V36.5C4 38.7091 5.79086 40.5 8 40.5H40C42.2091 40.5 44 38.7091 44 36.5V12.5C44 10.2909 42.2091 8.5 40 8.5Z"
                                                stroke="#F1913D" strokeWidth="2" strokeLinecap="round"
                                            />
                                            <path
                                                d="M44 14.5L26.06 25.9C25.4425 26.2869 24.7286 26.492 24 26.492C23.2714 26.492 22.5575 26.2869 21.94 25.9L4 14.5"
                                                stroke="#F1913D" strokeWidth="2" strokeLinecap="round"
                                            />
                                        </svg>

                                    </div>
                                    <div className="content">
                                        <div className="title text-1">
                                            Need live help
                                        </div>
                                        <h6 className="fw-4">
                                            <a href="mailto:support@coownspace.com" className='text-white'>
                                                support@coownspace.com
                                            </a>

                                        </h6>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="footer-main">
                        <div className="row">
                            <div className="col-lg-3 col-md-6">
                                <div className="footer-menu-list footer-col-block style-2">
                                    <h5 className="title lh-30 title-desktop">About us</h5>
                                    <h5 className="title lh-30 title-mobile">About us</h5>
                                    <ul className="tf-collapse-content">
                                        <li><a href="/">Home</a></li>
                                        <li><a href="/#aboutus">About CoOwnSpace</a></li>
                                        <li><a href="/#howcosworks">How CoOwnSpace Works</a></li>
                                        <li><a href="/#investwithcos">Invest with CoOwnSpace</a></li>
                                        <li><a href="/#ourmission">Our Mission</a></li>
                                        <li><a href="/#ourproperties">Our Properties</a></li>
                                        <li><a href="/#assestclass">Assest Class</a></li>
                                        <li><a href="/contact">Contact Us</a></li>
                                    </ul>
                                </div>
                            </div>
                            <div className="col-lg-3 col-md-6">
                                <div className="footer-menu-list footer-col-block">
                                    <h5 className="title lh-30 title-desktop">Popular house</h5>
                                    <h5 className="title lh-30 title-mobile">Popular house</h5>
                                    <ul className="tf-collapse-content">
                                        <li><a href="/properties">#Prime land</a></li>
                                        <li><a href="/properties">#Villa</a></li>
                                        <li><a href="/properties">#Farm land</a></li>
                                        <li><a href="/properties">#Rental Housing</a></li>
                                        <li><a href="/properties">#Property Lease</a></li>
                                        <li><a href="/properties">#Commercial Properties</a></li>
                                    </ul>
                                </div>
                            </div>
                            <div className="col-lg-3 col-md-6">
                                <div className="footer-menu-list footer-col-block style-2">
                                    <h5 className="title lh-30 title-desktop">Quick links</h5>
                                    <h5 className="title lh-30 title-mobile">Quick links</h5>
                                    <ul className="tf-collapse-content">
                                        <li><a href="/privacy-policy">Privacy Policy</a></li>
                                        <li><a href="/terms-conditions">Terms & Conditions</a></li>
                                        <li><a href="/">Refund Policy</a></li>
                                        <li><a href="faqs">FAQs</a></li>
                                    </ul>
                                </div>
                            </div>
                            <div className="col-lg-3 col-md-6">
                                <div className="footer-menu-list newsletter ">
                                    <h5 className="title lh-30 ">Newsletter</h5>
                                    <form className="form-newsletter" onSubmit={handleSubmit} id="subscribe-form" action="#" method="post"
                                        acceptCharset="utf-8" data-mailchimp="true">
                                            {success && <div className={success.includes('successfully') ? 'text-green-600' : 'text-red-600'}>{success}</div>}
                                        <p className="text-1">Sign up to receive the latest articles</p>
                                        <div id="subscribe-content">
                                            <fieldset>
                                                <input type="email" className="form-control text-white" placeholder="Email" name="email" value={formData.email} onChange={handleChange} />
                                                {errors.email && <small style={{ color: 'red' }}>{errors.email}</small>}
                                            </fieldset>
                                            <div className="checkbox-item">
                                                <fieldset>
                                                    <label>
                                                        <input type="checkbox" name="agree" checked={formData.agree} onChange={handleChange} />
                                                        <span className="text-2">I have read and agree to the terms &
                                                        conditions</span>
                                                        <span className="btn-checkbox"></span>
                                                    </label>
                                                    {errors.agree && <small style={{ color: 'red' }}>{errors.agree}</small>}
                                                </fieldset>
                                                {/* <label>
                                                    <span className="text-2">I have read and agree to the terms &
                                                        conditions</span>
                                                    <input type="checkbox" checked={isChecked}
                                                        onChange={() => setIsChecked(!isChecked)} />
                                                    <span className="btn-checkbox"></span>
                                                    {error && <p className="error-text">{error}</p>}
                                                </label> */}
                                            </div>
                                            <div className="button-submit">
                                                <button className="tf-btn bg-color-primary w-full" type="submit"
                                                    id="subscribe-button">Subscribe</button>
                                                {success && <div className={success && success.includes('successfully') ? 'text-success' : 'text-danger'}>{success}</div>}
                                            </div>
                                        </div>
                                        <div id="subscribe-msg"></div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-12">
                        <div className="footer-bottom">
                            <p>Copyright © 2025 <span className="fw-7">CoOwnSpace Infra Tech Pvt Ltd</span>
                                {/* . Designed & Developed
                                by
                                <a href="#">Themesflat</a> */}
                            </p>
                            <div className="wrap-social">
                                <div className="text-3  fw-6 text-white">Follow us</div>
                                <ul className="tf-social ">
                                    <li>
                                        <a target='_blank' href="https://www.facebook.com/coownspace" rel="noreferrer">
                                            <i className="icon-fb"></i>
                                        </a>
                                    </li>
                                    <li>
                                        <a target='_blank' href="https://www.linkedin.com/company/coownspace" rel="noreferrer">
                                            <i className="icon-linked"></i>
                                        </a>
                                    </li>
                                    <li>
                                        <a target='_blank' href="https://www.instagram.com/coownspace/" rel="noreferrer">
                                            <i className="icon-ins"></i>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    )
}

export default Footer